import React from "react";
import { Lock } from "lucide-react";
import PolicyShell from "../components/PolicyShell";

const SECTIONS = [
  {
    title: "What data we collect, and why",
    items: [
      "Name, email and (optionally) phone — used to manage your membership, send the newsletter, and respond to your enquiries.",
      "Donation history — required by UK law and our payment processor (Stripe) to record gift-aid eligibility (once registered) and produce accounts.",
      "Volunteer interest details — only what you give us via the /volunteer form, used by the coordinator team to contact you about roles.",
      "Charitable digital platform — user account credentials, attendance records for sessions you join, participation records (RSVPs, forum posts, votes, certificates), and in-platform communications. Used only to deliver and improve the charity's online charitable activities.",
      "Platform usage (login times, meeting attendance, meditation streaks) — used to evidence public benefit and recognise your contribution. Not sold or shared.",
      "Browser language preference and ambient music choice — saved locally in your browser only (localStorage), never transmitted.",
    ],
  },
  {
    title: "Who has access",
    items: [
      "ABGN-UK trustees and volunteers with a specific role (membership coordinator, newsletter editor, finance lead) on a need-to-know basis.",
      "Our payment processor (Stripe) for donation transactions only, under their own GDPR-compliant terms.",
      "Our email provider (Resend) to deliver newsletters and transactional emails. No bulk lists are sold or transferred.",
      "Where required by UK law (e.g. police, safeguarding referrals to statutory authorities, HMRC for gift-aid).",
    ],
  },
  {
    title: "Your rights under UK GDPR",
    items: [
      "Right of access — you can request a copy of the data we hold about you.",
      "Right of rectification — you can correct inaccurate data.",
      "Right of erasure — you can request that your account and associated data be deleted, subject to our legal record-keeping obligations.",
      "Right of objection — you can object to processing for specific purposes, e.g. unsubscribe from the newsletter at any time.",
      "Right to lodge a complaint — with the UK Information Commissioner's Office (ICO) at ico.org.uk.",
    ],
  },
  {
    title: "How long we keep data",
    items: [
      "Active member records: for the duration of membership plus 7 years (HMRC requirement).",
      "Donation records: 7 years (gift-aid retention period).",
      "Volunteer applications you submitted but didn't take up: 2 years, after which they are archived and then deleted.",
      "Newsletter list: until you unsubscribe (one-click in every issue).",
      "Meeting recordings: not retained unless you explicitly request a copy. AI Notes transcripts are stored under your account and deletable any time.",
    ],
  },
  {
    title: "Cookies",
    items: [
      "We use a single first-party session cookie to keep you logged in. No third-party tracking cookies. No advertising trackers.",
      "Google Analytics is not used.",
      "Embedded YouTube videos (where present in newsletter) use YouTube's own cookies in privacy-enhanced mode (youtube-nocookie.com where feasible).",
    ],
  },
  {
    title: "Contact",
    items: [
      "Data Protection contact: info@ambedkaritebuddhistglobalnetworkuk.com — we will respond within 30 calendar days as required by UK GDPR.",
      "Postal address available on request.",
    ],
  },
];

export default function Privacy() {
  return <PolicyShell
    icon={Lock}
    eyebrow="Policy"
    title="Privacy & data protection"
    intro="ABGN-UK is the data controller for the personal data you share with us. This page explains, in plain language, what we collect, why, and your rights under UK GDPR."
    sections={SECTIONS}
    approvedNote="Last updated February 2026 · Compliant with the UK GDPR and Data Protection Act 2018."
  />;
}
